<div class="card panel-flat-color primary-panel" style="height: 100%">
    <div class="panel-flat-header">
        <h3>Client Info</h3>
    </div>
    <div class="panel-flat-body position-relative" [formGroup]="form()">
        <div class="referral-field-grid">
            <label class="referral-field-label" for="engagementNumberAH">Engagement Number, AH</label>
            <referral-input-with-revert
                formControlName="engagementNumberAH"
                [systemValue]="systemReferral()?.engagementNumberAH"
                [originalValue]="originalReferral()?.engagementNumberAH"
                [isEngagementNumber]="true"
                (engagementDataLoaded)="onEngagementDataLoaded($event, true)"
                (engagementDataReverted)="onEngagementDataReverted($event)"
            />

            <label class="referral-field-label" for="engagementNumberJS">Engagement Number, JS</label>
            <referral-input-with-revert
                formControlName="engagementNumberJS"
                [systemValue]="systemReferral()?.engagementNumberJS"
                [originalValue]="originalReferral()?.engagementNumberJS"
                [isEngagementNumber]="true"
                (engagementDataLoaded)="onEngagementDataLoaded($event)"
            />

            <span class="referral-field-label">Client Name - Salesforce Account</span>
            <referral-input-with-revert
                formControlName="clientName"
                [systemValue]="systemReferral()?.clientName"
                [originalValue]="originalReferral()?.clientName"
                [maxlength]="255"
            />

            <span class="referral-field-label">Client Salesforce Account Number (CRM)</span>
            <referral-input-with-revert
                formControlName="clientNumber"
                [systemValue]="systemReferral()?.clientNumber"
                [originalValue]="originalReferral()?.clientNumber"
                [maxlength]="20"
            />

            <span class="referral-field-label" style="align-self: start" [style.margin-top.px]="editMode() ? 3 : 0">
                Client Address
            </span>
            <div>
                <referral-input-with-revert
                    formControlName="clientAddress1"
                    [systemValue]="systemReferral()?.clientAddress1"
                    [originalValue]="originalReferral()?.clientAddress1"
                    placeholder="Address 1"
                    [maxlength]="255"
                />
                <div>
                    <referral-input-with-revert
                        formControlName="clientAddress2"
                        [systemValue]="systemReferral()?.clientAddress2"
                        [originalValue]="originalReferral()?.clientAddress2"
                        placeholder="Address 2"
                        [maxlength]="255"
                    />
                </div>
                <div style="display: flex; gap: 4px">
                    <div style="display: flex">
                        <referral-input-with-revert
                            formControlName="clientCity"
                            [systemValue]="systemReferral()?.clientCity"
                            [originalValue]="originalReferral()?.clientCity"
                            placeholder="City"
                            [maxlength]="255"
                        />
                        @if (
                            !editMode() && (referral()?.clientCity || referral()?.clientState || referral()?.clientZip)
                        ) {
                            <span>,</span>
                        }
                    </div>
                    <referral-input-with-revert
                        formControlName="clientState"
                        [systemValue]="systemReferral()?.clientState"
                        [originalValue]="originalReferral()?.clientState"
                        placeholder="State"
                        [maxlength]="50"
                    />
                </div>
                <referral-input-with-revert
                    formControlName="clientZip"
                    [systemValue]="systemReferral()?.clientZip"
                    [originalValue]="originalReferral()?.clientZip"
                    placeholder="ZIP"
                    [maxlength]="20"
                />
            </div>

            <label class="referral-field-label" for="clientContactName">Client Contact Name</label>
            <referral-input-with-revert
                formControlName="clientContactName"
                [systemValue]="systemReferral()?.clientContactName"
                [originalValue]="originalReferral()?.clientContactName"
                [maxlength]="255"
            />

            <label class="referral-field-label" for="relationshipToProperty">Relationship to Property</label>
            <referral-input-with-revert
                formControlName="relationshipToProperty"
                [systemValue]="systemReferral()?.relationshipToProperty"
                [originalValue]="originalReferral()?.relationshipToProperty"
                [selectOptions]="relationshipToPropertyOptions"
            />

            <label class="referral-field-label" for="clientContactPhone">Client Contact Phone</label>
            <referral-input-with-revert
                formControlName="clientContactPhone"
                [systemValue]="systemReferral()?.clientContactPhone"
                [originalValue]="originalReferral()?.clientContactPhone"
                [maxlength]="20"
            />

            <label class="referral-field-label" for="clientContactEmail">Client Contact Email</label>
            <referral-input-with-revert
                formControlName="clientContactEmail"
                [systemValue]="systemReferral()?.clientContactEmail"
                [originalValue]="originalReferral()?.clientContactEmail"
                [maxlength]="100"
            />
        </div>
    </div>
</div>
